import { Lookup } from "../common/Lookup";
import { LookupDto } from "../shared/LookupDto";
import { MapLocation } from "../shared/MapLocation";
import { RegistrationModel } from "./registration.model";

export class BaseUserProfileModel{
    Username?: string;
    ParticipantNumber?: string;
    IsUAEPASS?: boolean;
    Token?: string;
    UUID?: string;
    IdNumber?: string;
    Passport?: string;
    NameAr?: string;
    NameEn?: string;
    NameUr?: string;
    Email?: string;
    Mobile?: string;
    SecondaryMobile?: string;
    PhoneNumber?: string;
    Fax?: string;
    PoBox?: string;
    EmirateId?: number;
    Emirate?: Lookup;
    ServiceCenterId?: number;
    ServiceCenter?: Lookup;
    BirthDate?: Date;
    Job?:Lookup;
    FamilyMembersNumber?: number;
    TotalIncome?: number;
    MaritalStatus?: Lookup;
    City?: string;
    Area?: string;
    Street?: string;
    Address?: string;
    PreferedLanguageCode?: string;
    PreferedLanguage?: Lookup;
    NotificationTypeCodes?: string[];
    NotificationTypes?: Lookup[];
    IsVerified?: boolean;
    IsOwner?: boolean;
    Agents?: UserProfileAgentModel[];
}

export interface AgentDto {
    IdentityType?: string;
    IdentityNumber?: string;
    Name?: string;
    Email?: string;
    Phone?: string;
    PreferedLanguage?: string;
}

export class PersonProfileModel extends BaseUserProfileModel{
    NationalityId?: number;
    NationalityCode?: string;
    Nationality?: Lookup;
    ResidencyTypeId?: number;
    ResidencyType?: Lookup;
    Gender?: Lookup;
    HasDisability?: boolean;
    DisabilitiesIds?: number[];
    Disabilities?: Lookup[];
}

export class AuthorityProfileModel extends BaseUserProfileModel{
    LegalStatusId?: number;
    LegalStatus?: Lookup;
    LicenseIssuerId?: number;
    LicenseIssuerCode?: string;
    LicenseIssuer?: Lookup;
    LicenseTypeCode?: string;
    LicenseType?: Lookup;
    LicenseNumber?: string;
    LicenseIssuanceDate?: Date;
    LicenseExpiryDate?: Date;
    Location?:MapLocation;
    Latitude?: string;
    Longtuide?: string;
    Owners?: AuthorityOwnerModel[];
}

export class AuthorityOwnerModel{
    Id?: number;
    PartnershipTypeId?: number;
    PartnershipType?: Lookup;
    IdType?: string;
    IdNumber?: string;
    Passport?: string;
    NameAr?: string;
    NameEn?: string;
    NationalityId?: number;
    Nationality?: Lookup;
    Mobile?: string;
    IsDeleted?: boolean;
    IsUpdated?: boolean;
}

export class UserProfileAgentModel{
    Id?: number;
    IdentityType?: string;
    IdNumber?: string;
    Passport?: string;
    NameAr?: string;
    NameEn?: string;
    Mobile?: string;
    Email?: string;
    PreferedLanguageCode?: string;
    PreferedLanguage?: Lookup;
    LoginPermission?: boolean;
    IsDefaultAgent?: boolean;
    IsDeleted?: boolean;
    IsUpdated?: boolean;
}

export class UserProfileLookupsModel{
    Countries: LookupDto[];
    Emirates: LookupDto[];
    ResidencyTypes: LookupDto[];
    Genders: LookupDto[];
    DisabilityType: LookupDto[];
    LegalStatuses: LookupDto[];
    PartnershipTypes: LookupDto[];
    LicenseIssuers: LookupDto[];
    LicenseTypes: LookupDto[];
    Languages: LookupDto[];
    GeoAreas: LookupDto[];
    ServiceCenters: LookupDto[];
    Jobs: LookupDto[];
    MaritalStatuses: LookupDto[];
    NotificationMethods: LookupDto[];
}

export class AuthorityRegistrationLookup{
    Countries: LookupDto[];
    Emirates: LookupDto[];
    LegalStatuses: LookupDto[];
    PartnershipTypes: LookupDto[];
    LicenseTypes: LookupDto[];
}

export class PersonRegistrationLookup{
    ResidencyTypes: LookupDto[];
    Genders: LookupDto[];
}

export class UserProfileLookups{
    Genders: Lookup[] = [];
    Countries: Lookup[] = [];
    Emirates: Lookup[] = [];
    ResidencyTypes: Lookup[] = [];
    Disabilities: Lookup[] = [];
    LegalStatuses: Lookup[] = [];
    PartnershipTypes: Lookup[] = [];
    LicenseIssuers: Lookup[] = [];
    LicenseTypes: Lookup[] = [];
    Languages: Lookup[] = [];
    GeoAreas: Lookup[] = [];
    ServiceCenters: Lookup[] = [];
    Jobs: Lookup[] = [];
    MaritalStatuses: Lookup[] = [];
    NotificationTypes: Lookup[] = [];
}

export class UserProfileResponseModel{
    IsPerson: boolean;
    Person: PersonProfileModel;
    Authority: AuthorityProfileModel;
    Lookups: UserProfileLookupsModel;
}

export class UserProfileDtoResponseModel{
    ProfileData:RegistrationModel
    AuthorityRegistrationLookup: UserProfileLookupsModel;
    PersonRegistrationLookup: UserProfileLookupsModel;
    IsPowerUser: boolean;
}